import styled from "styled-components"
import { Asset } from "../../graphql/contentful/types"

const image = styled.img.attrs<Asset>(
  ({ url, description }) =>
    ({
      src: url,
      alt: description,
    }) satisfies React.HTMLProps<HTMLImageElement>,
)`
  width: 100%;
  object-fit: cover;
  aspect-ratio: 4 / 3;
  border-radius: ${({ theme }) => theme.borders.softRadius};
`

export default image
